import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Tooltip } from '../ui/Tooltip';

const StyledLink = styled(Link)`
  display: inline-block;
  padding: 6px;
  background: rgba(255, 255, 255, 0.3);
  line-height: 1;
  color: #fff;
  width: 172px;
  margin-left: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const HeaderWorkspace = ({ link, label }: { link: string; label: string }) => {
  return (
    <Tooltip title={label}>
      <StyledLink to={link}>{label}</StyledLink>
    </Tooltip>
  );
};

HeaderWorkspace.defaultProps = {
  link: '/',
};

export { HeaderWorkspace };
